module.exports = __webpack_public_path__ + "img/monitor.e8d99934.svg";